$(document).ready(function () {
    var patientVideoPlayer = new evoke.ui.VimeoPlayer({
        container: "#patientVideoPlayer",
        includeCloseButton: true,
        videos: [
          { name: "terry", callouts: ["facts", "copay"] },
          { name: "mitch", callouts: ["facts", "copay"] },
          { name: "carol", callouts: ["facts", "copay"] },
          { name: "commercial", callouts: ["facts", "copay"] }
        ]
    });
    patientVideoPlayer.ready(function () {
        $(".video-play").click(function (e) {
            e.preventDefault();
            $(".video-container").hide();
            $("#testimonial").addClass("blur");
            $("#patientVideoPlayer").show();
            patientVideoPlayer.play("terry", $(this).data("vidstart"));
        });
        patientVideoPlayer.find(".VideoPlayer_close").on('click', function (e) {
            e.preventDefault();
            $("#patientVideoPlayer").hide().prev(".video-container").show();
            patientVideoPlayer.pause();
        });
    });
});